import React, { useState } from 'react'

const Tooltip = ({ children, text, width = '200px', position = 'top', className = '' }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [isMobile] = useState(window.innerWidth <= 768)

  const tooltipStyle = {
    position: isMobile ? 'fixed' : 'absolute',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    color: 'white',
    padding: '5px 10px',
    borderRadius: '4px',
    fontSize: '14px',
    textTransform: 'none',
    letterSpacing: '0px',
    fontFamily: '"DM Sans", sans-serif',
    fontWeight: '400',
    zIndex: 1000000,
    whiteSpace: 'normal',
    width: isMobile ? '90vw' : width || undefined,
    ...(isMobile
      ? {
          left: '50%',
          transform: 'translateX(-50%)',
          top: '20px',
        }
      : position === 'top'
        ? {
            bottom: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            marginBottom: '5px',
          }
        : {
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            marginTop: '5px',
          }),
  }

  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
    maxWidth: '250px',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
  }

  const defaultIcon = (
    <svg width='16' height='16' viewBox='0 0 16 16' className='ms-2' style={{ cursor: 'default' }}>
      <circle cx='8' cy='8' r='7' stroke='black' strokeWidth='1.5' fill='none' />
      <text
        x='8'
        y='11.5'
        textAnchor='middle'
        fill='black'
        style={{ font: 'bold 11px sans-serif' }}
      >
        ?
      </text>
    </svg>
  )

  return (
    <div
      style={containerStyle}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      className={className}
    >
      {isVisible && <div style={tooltipStyle}>{text}</div>}
      {children || defaultIcon}
    </div>
  )
}

export default Tooltip
